'use strict';

exports.__esModule = true;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };

var validateClass = exports.validateClass = function validateClass(clazz, decorator) {
  if (typeof clazz !== 'function') {
    throw new Error('@' + decorator + ' decorator can only be applied to class not: ' + (typeof clazz === 'undefined' ? 'undefined' : _typeof(clazz)));
  }
};

var validateFunction = exports.validateFunction = function validateFunction(func, decorator) {
  if (typeof func !== 'function') {
    throw new Error('@' + decorator + ' decorator can only be applied to methods not: ' + (typeof func === 'undefined' ? 'undefined' : _typeof(func)));
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/react-decoration/lib/utils/validators.js
// module id = 4
// module chunks = 1